export default "__VITE_ASSET__BGsrC$dE__"